import { apiErrorFromResponse, apiFetch } from "./client.js";

export interface Attachment {
    id: number;
    entity: "ereignis" | "risiko" | "massnahme";
    entityId: number;
    filename: string;
    mimeType: string;
    sizeBytes: number;
    uploadedByUserId: number | null;
    uploadedAt: number;
}

const ENTITY_PATH = { ereignis: "ereignisse", risiko: "risiken", massnahme: "massnahmen" } as const;

export const attachmentsApi = {
    list: (entity: keyof typeof ENTITY_PATH, id: number) =>
        apiFetch<{ items: Attachment[] }>(`/api/${ENTITY_PATH[entity]}/${id}/attachments`),

    // Bypasses apiFetch on purpose: a multipart body must not carry a JSON
    // content-type (apiFetch always sets one whenever a body is present).
    // fetchImpl mirrors apiFetch's own injectable-fetch parameter so this is
    // testable the same way, without a real network call.
    upload: async (
        entity: keyof typeof ENTITY_PATH,
        id: number,
        file: File,
        fetchImpl: typeof fetch = fetch,
    ): Promise<Attachment> => {
        const fd = new FormData();
        fd.append("file", file);
        const res = await fetchImpl(`/api/${ENTITY_PATH[entity]}/${id}/attachments`, {
            method: "POST", body: fd, credentials: "same-origin",
        });
        if (!res.ok) {
            const json = await res.json().catch(() => null);
            throw apiErrorFromResponse(res, json);
        }
        return res.json();
    },

    remove: (id: number) => apiFetch<null>(`/api/attachments/${id}`, { method: "DELETE" }),

    downloadUrl: (id: number) => `/api/attachments/${id}`,
};
